import { useAuthUser } from 'auth/hooks';
import { FormProvider } from 'core/states';
import { QuoteEntityType } from 'quotes/enums';
import { ICustomerQuote } from 'quotes/types';

import QuoteVersionReleaseFormView from './QuoteVersionReleaseFormView';
import { quoteVersionReleaseSchema } from './schema';
import { useSubmitActions } from './useSubmitActions';

interface IProps {
  isOpen?: boolean;
  onClose?: () => void;
  quote: ICustomerQuote;
  entityType?: QuoteEntityType;
}

const QuoteVersionReleaseForm = ({
  isOpen = false,
  onClose,
  quote,
  entityType = QuoteEntityType.QUOTE,
}: IProps) => {
  const { user } = useAuthUser();

  const { getSubmitActions, handleOnClose } = useSubmitActions(quote, onClose, user, entityType);

  return (
    <FormProvider schema={quoteVersionReleaseSchema()}>
      <QuoteVersionReleaseFormView
        isOpen={isOpen}
        onClose={handleOnClose}
        getSubmitActions={getSubmitActions}
      />
    </FormProvider>
  );
};

export default QuoteVersionReleaseForm;
